import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import * as types from './types';
export default {
  [types.SET_CART_SUCCESS](state, payload) {
    const currentState = state;
    currentState.customer.cartSuccess = payload;
  },

  [types.SET_CUSTOMER](state, payload) {
    const currentState = state;
    currentState.customer = _objectSpread({}, currentState.customer, payload);
  },

  [types.SET_CART](state, payload) {
    const currentState = state;
    currentState.customer.cart = payload.cart;
  },

  [types.PUSH_CART](state, payload) {
    const currentState = state;
    currentState.customer.cart += Number(payload.quantity);
  },

  [types.SET_CURRENT_ITEM_QTY](state, payload) {
    const currentState = state;
    currentState.customer.cartItems[payload.reference] = Number(payload.quantity);
  }

};